// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./Components/Header/Header";
import LandingPage from "./Pages/LandingPage/LandingPage";
import TeamsPage from "./Pages/TeamsPage/TeamsPage";
import LeaguesPage from "./Pages/LeaguesPage/LeaguesPage";
import RulesPage from "./Pages/RulesPage/RulesPage";
import About from "./Pages/About/About";
import Registration from "./Pages/Registration/Registration";
import RegistrationForm from "./Pages/Registration/RegistrationForm";
import PastEventsPage from "./Pages/PastEventsPage/PastEventsPage";
import Unsubscribe from "./Pages/Unsubscribe/Unsubscribe";
import EventPage from "./Pages/EventPage/EventPage";
import PopupModal from "./Components/PopupModal/PopupModal";

export default function App() {
  return (
    <BrowserRouter>
      <Header />
      <PopupModal />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/teams" element={<TeamsPage />} />
        <Route path="/leagues" element={<LeaguesPage />} />
        <Route path="/rules" element={<RulesPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/register/:slug" element={<RegistrationForm />} />
        <Route path="/hall-of-fame" element={<PastEventsPage />} />
        <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
        <Route path="/e/:slug" element={<EventPage />} />
      </Routes>
    </BrowserRouter>
  );
}
